.skyWrapper {
  display: flex;
  align-items: stretch;
  justify-content: center;
  width: 100%;
  gap: 1rem;

  & > .side {
    display: grid;
    align-content: space-between;
    flex-grow: 1;

    .withSnapFeed & {
      display: none;
    }
  }

  & > .left {
    padding-left: 1rem;

    &::after {
      content: "";
      display: block;
      width: 208px;
    }

    .phone & {
      display: none;
    }
  }

  & > .right {
    align-content: start;
    padding-right: 1rem;
    min-height: calc(929px + 4rem);

    .phone & {
      display: none;
    }

    .skyscraperSentinel {
      height: 1px;
      pointer-events: none;
    }

    .skyscraper_sticky {
      position: sticky;
      top: var(--header-height);
      transition: top 0.5s;

      .scrolled & {
        top: 0;
      }
    }

    .skyscraper_stuck {
      max-height: calc(var(--app-height) - var(--header-height));
      overflow-y: auto;
      overscroll-behavior: contain;
    }
  }

  & > .middle {
    max-width: 100%;

    &:first-child {
      width: 100%;
    }

    @supports (-webkit-touch-callout: none) {
      width: 100%;
    }
  }
}
